export const MAX_MOBILE_SIZE = 600;
export const AVATAR_PATH = "/images/studioverse/creators/creator-def.png";
export const DEFAULT_PRESET_IMAGE_PATH = "/images/studioverse/presets/preset-def.png";
export const OLP_DESKTOP_BREAKPOINT = 1200;

export const MAX_TABLET_WIDTH = 820;

export const FACEBOOK_SHARE_PATH = "https://www.facebook.com/sharer/sharer.php?u=";
export const INSTAGRAM_SHARE_PATH = "https://www.instagram.com/sharer.php?u=";
export const TWITTER_SHARE_PATH = "https://twitter.com/intent/tweet?url=";



